import { BundleType } from '@order/orderTypes'
import { useLocalSearchParams } from 'expo-router'

export type BundleParams = {
  bundleType?: string
}

const useBundleType = (params?: BundleParams) => {
  const { bundleType = 'base' } = useLocalSearchParams<{
    bundleType: BundleType
  }>()

  const currentBundle = params?.bundleType || bundleType

  //Fixme type
  return {
    bundleType,
    dealKey: currentBundle === 'base' ? 'base' : 'extra',
    dealUpgradeKey: currentBundle === 'base' ? 'upgrade' : 'extraUpgrade',
  } as const
}

export default useBundleType
